import React from "react";
import PropTypes from "prop-types";
import StructuralVariant from "../../../../../../models/StructuralVariant";
import PublicationLinks from "../../../../../../components/Publications/components/PublicationLinks";
import castArray from "../../../../../../common/helpers/castArray";
import { pluralize } from "../../../../../../common/helpers/helpers";

function DGV({ item }) {
  const data = item?.regionData || {};
  const obs = data?.Observations || {};
  const obsGains = obs["Observed Gains"] || "";
  const obsLosses = obs["Observed Losses"] || "";
  const pmids = castArray(item.regionData.PUBMEDIDS);

  return (
    <div className="tw-px-1 tw-py-px">
      <div>
        {item?.regionData?.Accession ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-28">Accession</div>
            <div className="tw-flex-grow">{item.regionData.Accession}</div>
          </div>
        ) : null}
        {obsGains ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-28">Observed gains</div>
            <div className="tw-flex-grow">{obsGains}</div>
          </div>
        ) : null}
        {obsLosses ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-28">Observed Losses</div>
            <div className="tw-flex-grow">{obsLosses}</div>
          </div>
        ) : null}

        {item?.regionData?.PUBMEDIDS ? (
          <div className="tooltip-row">
            <div className="tooltip-label tw-w-28">PubMed</div>
            <PublicationLinks
              ids={pmids}
              className="tw-text-blue-500 tw-cursor-pointer"
            >
              {pmids?.length} {pluralize(pmids?.length, "PMID", "PMIDs")}
            </PublicationLinks>
          </div>
        ) : null}
      </div>
    </div>
  );
}

DGV.propTypes = {
  item: PropTypes.instanceOf(StructuralVariant).isRequired,
};

DGV.defaultProps = {};

export default DGV;
